/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import './ErrorBoundary.scss';
import ErrorPage from 'components/shared/ErrorPage/ErrorPage';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import LogoutPage from 'components/pages/Logout/LogoutPage';
import { LOGIN } from '../../../services/Externals';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log(error.toString(), errorInfo.componentStack);
    if (error) {
      this.setState({
        hasError: true,
        error: error.toString(),
        errorInfo: errorInfo.componentStack
      });
    }
  }

  render() {
    const { error } = this.state;
    const { router } = this.props;
    const {
      location: { pathname }
    } = router;
    const onLogout = pathname === '/logout';
    const { hasError } = this.state;
    if (onLogout) {
      return <LogoutPage forceLogout />;
    }
    if (hasError) {
      if (
        error.indexOf('AuthGate') !== -1 ||
        error.indexOf('TokenExchange') !== -1
      ) {
        window.location.href = LOGIN;
      }

      if (
        error.indexOf(`token responded with unexpected response: false`) !== -1
      ) {
        window.location.href = LOGIN;
      }
      return <ErrorPage />;
    }
    const { children } = this.props;
    return children;
  }
}

const mapStateToProps = (state) => {
  return state;
};
export default withRouter(connect(mapStateToProps)(ErrorBoundary));
